import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

import { Iconify } from 'src/components/iconify';

import TableAdvanceFilter from '../core/table-advanceFilter-custom';

// ----------------------------------------------------------------------

type ToolbarControlsProps = {
  selectedfilters: any;
  dateTimeFiltre: any;
  handleRemoveAllFilter: () => void;
  columnPopoverOnOpen: () => void;
  isToolbarVisible: boolean;
  isSearchInput: boolean;
  searchTerm: string;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSearchKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  refreshPage?: () => void;
  refreshing: boolean;
  isAdvanceFilter: boolean;
  advanceFilterFields: any;
  setAdvanceFilter: any;
  advanceFilters: any;
  resetPagination: any;
  isActionButton: Array<'import' | 'export'>;
  isExport: boolean;
  isImport: boolean;
  menuActionsOnOpen: () => void;
  t: (key: string) => string;
  columns?: any[];
  customFields?: any[];
};

// ----------------------------------------------------------------------

export function ToolbarControls({
  selectedfilters,
  dateTimeFiltre,
  handleRemoveAllFilter,
  columnPopoverOnOpen,
  isToolbarVisible,
  isSearchInput,
  searchTerm,
  handleSearchChange,
  handleSearchKeyDown,
  refreshPage,
  refreshing,
  isAdvanceFilter,
  advanceFilterFields,
  setAdvanceFilter,
  advanceFilters,
  resetPagination,
  isActionButton,
  isExport,
  isImport,
  menuActionsOnOpen,
  t,
  columns,
  customFields,
}: ToolbarControlsProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {((selectedfilters && Object.keys(selectedfilters).length > 0) ||
        (dateTimeFiltre && dateTimeFiltre.length > 0) ||
        (advanceFilters && advanceFilters.length > 0)) && (
        <Button onClick={handleRemoveAllFilter} sx={{ p: 1 }}>
          <Iconify icon="solar:trash-bin-trash-bold" sx={{ mr: 0.5 }} />
          {t('CLEAR_FILTERS')}
        </Button>
      )}
      <Tooltip title={t('MANAGE_COLUMNS')}>
        <IconButton onClick={columnPopoverOnOpen}>
          <Iconify icon="mingcute:column-fill" />
        </IconButton>
      </Tooltip>

      {isToolbarVisible && isSearchInput && (
        <TextField
          size="small"
          value={searchTerm}
          onChange={handleSearchChange}
          onKeyDown={handleSearchKeyDown}
          placeholder={`${t('SEARCH')}...`}
          sx={{ width: 200 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            ),
          }}
        />
      )}

      {refreshPage && (
        <Tooltip title={t('REFRESH')}>
          <IconButton onClick={refreshPage} color="primary" disabled={refreshing}>
            <Iconify icon="solar:restart-bold" />
          </IconButton>
        </Tooltip>
      )}

      {/* Advance Filter */}
      {isAdvanceFilter && (
        <TableAdvanceFilter
          advanceFilterFields={advanceFilterFields}
          setAdvanceFilter={setAdvanceFilter}
          advanceFilters={advanceFilters}
          resetPagination={resetPagination}
          columns={columns}
          customFields={customFields}
        />
      )}

      {/* Import/Export */}
      {isActionButton?.length > 0 && (isExport || isImport) && (
        <IconButton onClick={menuActionsOnOpen}>
          <Iconify icon="eva:more-vertical-fill" />
        </IconButton>
      )}
    </Box>
  );
}
